import { create } from "zustand";

/** The assistant drawer: opened from the floating button or from a person, optionally about that person. */
interface AskDrawerState {
  open: boolean;
  contactId: string | null;
  openAsk(contactId?: string | null): void;
  closeAsk(): void;
}

export const useAskDrawer = create<AskDrawerState>((set) => ({
  open: false,
  contactId: null,
  openAsk: (contactId = null) => set({ open: true, contactId }),
  closeAsk: () => set({ open: false }),
}));
